import { render, staticRenderFns } from "./ProfileLiteraryAbilities.vue?vue&type=template&id=678aeb46&scoped=true"
import script from "./ProfileLiteraryAbilities.vue?vue&type=script&lang=js"
export * from "./ProfileLiteraryAbilities.vue?vue&type=script&lang=js"
import style0 from "./ProfileLiteraryAbilities.vue?vue&type=style&index=0&id=678aeb46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678aeb46",
  null
  
)

export default component.exports